// extracted by mini-css-extract-plugin
export default {"path":"search-client-js-components-results-___Path-module__path___YUygc"};